module.exports = __webpack_public_path__ + "ath_game_web/img/4.1.06e63d88.png";